<button  type="button" kendoButton  *ngIf="pedido.pedirNovamente"
         class="k-button k-primary ml-2"  title="duplicar pedido" (click)="duplicarPedido()" kendoTooltip>
  <i class="k-icon k-i-copy mr-1"></i> <span *ngIf="exibirTexto">copiar</span>
</button>
